import config from "config";

import { useChargebeeScriptLoader } from "./useChargebeeScriptLoader";

export function useChargebeeWithConfig() {
  const { site, publishableKey } = config.chargebee;

  return useChargebeeScriptLoader(site, publishableKey);
}

export default useChargebeeWithConfig;
